import { Icon } from "@newsela/angelou";

import {
  noResultsContainerCss,
  noResultsHeadingCss,
  noResultsParagraphCss,
  noResultsTextContainerCss,
} from "@/search/Langston/SearchResults/NoResults/NoResults.styles";
import { NoResultsSVG } from "@/search/Langston/SearchResults/NoResults/NoResultsSVG";

const NoResults = () => {
  return (
    <div css={noResultsContainerCss}>
      <Icon SvgComponent={NoResultsSVG} />

      <div css={noResultsTextContainerCss}>
        <h4 css={noResultsHeadingCss}>No results</h4>
        <p css={noResultsParagraphCss}>
          Try a new search or change your filters.
        </p>
      </div>
    </div>
  );
};

NoResults.displayName = "NoResults";
export { NoResults };
